import React from "react"
import icons from "@treefort/tokens/app/icons"
import Icon from "./icon"

export default function ProgressFinishedBadge(): React.JSX.Element {
  return <Icon source={icons.checkCircle.fill} size="small" color="accent" />
}
